/** Transport-level error thrown by the API client (and the demo client). */
export class RequestError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string
  ) {
    super(message);
  }
}
